import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useStanQuery } from '@/queries';
import { QUERY_KEYS, SENTRY_FEATURES } from '@/lib/constants';
import { getTaxSettings, type TaxSettingsUpdatePayload, updateTaxSettings } from '@/lib/api/settings';

/**
 * Query hook to fetch tax settings
 * Only enabled when Stripe is connected
 */
export const useTaxSettings = (enabled = true) => {
    return useStanQuery({
        queryKey: [QUERY_KEYS.TAX_SETTINGS],
        queryFn: getTaxSettings,
        enabled,
        staleTime: 1000 * 60 * 5, // 5 minutes
        meta: {
            error: {
                feature: SENTRY_FEATURES.SETTINGS,
                sentryMessage: '[SETTINGS] failed-to-fetch-tax-settings',
            },
        },
    });
};

/**
 * Mutation hook to update tax settings
 */
export const useTaxSettingsMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: TaxSettingsUpdatePayload) => updateTaxSettings(payload),
        onSuccess: () => {
            // Invalidate and refetch tax settings after update
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.TAX_SETTINGS] });
        },
    });
};
